/**
 * Tờ "Góp ý cho SAPA" (docs/plans/qr-sapa-va-nut-phan-hoi.md, mục 4.2).
 * Một ô bắt buộc (chữ). Tự kèm màn đang mở, bản web, khổ màn; KHÔNG gửi tenant (máy chủ lấy từ phiên).
 * Lỗi: giữ nguyên chữ đã gõ. Gửi xong: `onDaGui` (cha đóng tờ + báo).
 */
import { LOAI_PHAN_HOI, type LoaiPhanHoi, PHAN_HOI_TOI_DA_KY_TU } from '@sapa/shared'
import { useEffect, useRef, useState } from 'react'
import { ApiFailure, phanHoi } from './api.ts'
import { coTheGui, dungThanPhanHoi, kyTuConLai } from './phan-hoi-kem.ts'
import { tenBanDangChay } from './qr-sapa.ts'
import { PH } from './text/phan-hoi.ts'
import { ThongBao, To } from './ui.tsx'

/** 'khac' là mặc định khi không chọn → không có chip. */
const LOAI_CHIP = LOAI_PHAN_HOI.filter((l) => l !== 'khac')

export function ToPhanHoi({
  man,
  onDong,
  onDaGui,
}: {
  man: string
  onDong: () => void
  onDaGui: () => void
}) {
  const [loai, setLoai] = useState<LoaiPhanHoi | null>(null)
  const [chu, setChu] = useState('')
  const [dang, setDang] = useState(false)
  const [loi, setLoi] = useState<string | null>(null)
  const dangGui = useRef(false)
  const tieuDeRef = useRef<HTMLHeadingElement>(null)

  // Đưa focus vào tờ (không mở bàn phím ngay trên điện thoại).
  useEffect(() => {
    tieuDeRef.current?.focus()
  }, [])

  async function gui() {
    if (dangGui.current || !coTheGui(chu)) return
    dangGui.current = true
    setDang(true)
    setLoi(null)
    try {
      await phanHoi.gui(
        dungThanPhanHoi({
          loai,
          chu,
          trang: man,
          banWeb: tenBanDangChay(),
          rongManPx: window.innerWidth,
        }),
      )
      onDaGui()
    } catch (e) {
      // Mất mạng (status 0) → câu chung của tờ; còn lại máy chủ đã nói bằng tiếng Việt thì hiện đúng câu đó.
      setLoi(e instanceof ApiFailure && e.status !== 0 ? e.messageVi : PH.chuaGuiDuoc)
      dangGui.current = false
      setDang(false)
    }
  }

  return (
    <To nhan={PH.tieuDe} onDong={onDong}>
      <div className="to-than gop-y">
        <h2 ref={tieuDeRef} tabIndex={-1}>
          {PH.tieuDe}
        </h2>
        <p className="chu-phu">{PH.goiY}</p>
        <div className="gop-y-nhom">
          <label className="nhan" htmlFor="gop-y-noi-dung">
            {PH.oNhan}
          </label>
          <textarea
            id="gop-y-noi-dung"
            className="o-nhap gop-y-o"
            rows={4}
            maxLength={PHAN_HOI_TOI_DA_KY_TU}
            placeholder={PH.oGoiY}
            value={chu}
            onChange={(e) => setChu(e.target.value)}
          />
          <p className="gop-y-dem">{PH.conLai(kyTuConLai(chu))}</p>
        </div>
        <fieldset className="gop-y-nhom gop-y-loai">
          <legend className="nhan">{PH.loaiNhan}</legend>
          <div className="hang-chip chia-deu cot-2">
            {LOAI_CHIP.map((l) => (
              <button
                key={l}
                type="button"
                className={`chip ${loai === l ? 'dang-chon' : ''}`}
                aria-pressed={loai === l}
                onClick={() => setLoai(loai === l ? null : l)}
              >
                {PH.loai[l]}
              </button>
            ))}
          </div>
        </fieldset>
        <p className="gop-y-kem">{PH.guiKem}</p>
        {loi !== null && (
          <ThongBao loai="loi" lon>
            {loi}
          </ThongBao>
        )}
      </div>
      <div className="to-chan">
        <button type="button" className="nut nut-vien" onClick={onDong}>
          {PH.huy}
        </button>
        <button
          type="button"
          className="nut nut-chinh"
          disabled={dang || !coTheGui(chu)}
          onClick={() => void gui()}
        >
          {dang ? PH.dangGui : PH.gui}
        </button>
      </div>
    </To>
  )
}
